var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchFiltersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 28,
    viewBox: "0 0 30 28.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "sliders-solid",
    d: "M0,39.438a1.873,1.873,0,0,0,1.875,1.875H5.08a4.686,4.686,0,0,0,8.59,0H28.125a1.875,1.875,0,0,0,0-3.75H13.67a4.686,4.686,0,0,0-8.59,0H1.875A1.873,1.873,0,0,0,0,39.438Zm7.5,0a1.875,1.875,0,1,1,1.875,1.875A1.875,1.875,0,0,1,7.5,39.438Zm11.25-9.375a1.875,1.875,0,1,1,1.875,1.875A1.875,1.875,0,0,1,18.75,30.063Zm1.875-4.687a4.678,4.678,0,0,0-4.295,2.813H1.875a1.875,1.875,0,0,0,0,3.75H16.33a4.686,4.686,0,0,0,8.59,0h3.205a1.875,1.875,0,0,0,0-3.75H24.92A4.678,4.678,0,0,0,20.625,25.375ZM11.25,22.563a1.875,1.875,0,1,1,1.875-1.875A1.875,1.875,0,0,1,11.25,22.563Zm4.295-3.75a4.686,4.686,0,0,0-8.59,0H1.875a1.875,1.875,0,0,0,0,3.75h5.08a4.686,4.686,0,0,0,8.59,0h12.58a1.875,1.875,0,0,0,0-3.75Z",
    transform: "translate(0 -16)",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFiltersIcon);
export default __webpack_public_path__ + "static/media/search-filters-icon.d304e603fa3a65105a60589d74ee51fb.svg";
export { ForwardRef as ReactComponent };